import { useState } from 'react'
import Styles from './ChatAssistant.module.scss'
import { ChatMessages } from 'components/ChatAssistant/Messages/ChatMessages'
import { ChatInput } from 'components/ChatAssistant/ChatInput/ChatInput'
import { ChatAssistantProps } from './Types'
import { useCreateThread } from 'hooks/queries/chat/useCreateThread'
import { useCreateMessage } from 'hooks/queries/chat/useCreateMessage'
import { ChatMessageContent } from 'api/clients/ChatClient'
import { collectResults } from 'utils/query'
import { useInfiniteMessages } from 'hooks/queries/chat/useInfiniteMessages'
import { AIJobStatus } from 'types'

const ChatAssistant = ({ threadId, fileId, setSelectedThreadId, inputPlaceholder, context }: ChatAssistantProps) => {
  const [value, setValue] = useState('')
  const { mutate: createThread, isLoading: isCreatingThread } = useCreateThread()
  const { mutate: createMessage, isLoading: isCreatingMessage } = useCreateMessage()
  const isLoading = isCreatingThread || isCreatingMessage
  const messagesQuery = useInfiniteMessages({ threadId, items: 5 })
  const messages = collectResults(messagesQuery, (data) => data.messages)
  const isProcessing = messages.some(
    (message) => message.status && [AIJobStatus.Pending, AIJobStatus.Started].includes(message.status),
  )

  const handleSubmit = () => {
    let content: ChatMessageContent[] = [{ type: 'text', text: value }]
    if (context) {
      content.push({ type: 'context', context })
    }

    if (!threadId) {
      createThread(
        { content, fileId },
        {
          onSuccess: (data) => {
            setValue('')
            setSelectedThreadId(data.thread.id)
          },
        },
      )
    } else {
      createMessage(
        { threadId, content },
        {
          onSuccess: () => {
            setValue('')
          },
        },
      )
    }
  }

  return (
    <div className={Styles.root}>
      <ChatMessages threadId={threadId} setValue={setValue} />
      <div className={Styles.footerContainer}>
        <ChatInput
          value={value}
          onChange={setValue}
          placeholder={inputPlaceholder}
          onSubmit={handleSubmit}
          isDisabled={isLoading || isProcessing}
          threadId={threadId}
          fileId={fileId}
        />
      </div>
    </div>
  )
}

export { ChatAssistant }
